// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3WCob","file":"styles_file__12p1k"};